"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericVocabularyService = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../../constants/constants");
var networkServiceDefault_1 = require("../network/networkServiceDefault");
var sdk_1 = require("../../sdk/sdk");
/**
 * Implementation of the VocabularyProvider interface for a generic vocabulary service.
 * @class
 * @implements {VocabularyProvider}
 */
var GenericVocabularyService = /** @class */ (function () {
    function GenericVocabularyService(networkService) {
        if (networkService === void 0) { networkService = new networkServiceDefault_1.NetworkServiceDefault(); }
        this.networkService = networkService;
    }
    GenericVocabularyService.prototype.fetchVocabulary = function (language) {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var vocabularyEndpoint, apiEndpointBaseUrl, languageOption, url, requestable, vocabularyData, error_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        if (!sdk_1.VelvetSDK.Configuration.configuration) return [3 /*break*/, 2];
                        vocabularyEndpoint = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.apiEndpoints.vocabulary;
                        apiEndpointBaseUrl = (_b = sdk_1.VelvetSDK.Configuration.configuration) === null || _b === void 0 ? void 0 : _b.apiEndpointBaseUrl;
                        languageOption = language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE;
                        url = vocabularyEndpoint
                            .replace(constants_1.CMS.BASE_URL, apiEndpointBaseUrl)
                            .replace(constants_1.CMS.LANGUAGE, language !== null && language !== void 0 ? language : languageOption);
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 1:
                        vocabularyData = _c.sent();
                        sdk_1.VelvetSDK.Vocabulary.vocabulary = vocabularyData;
                        sdk_1.VelvetSDK.Vocabulary.isVocabFetching = false;
                        _c.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        console.error('Error fetching vocabulary: ', error_1);
                        sdk_1.VelvetSDK.Vocabulary.isVocabFetching = false;
                        throw new Error('Failed to fetch vocabulary data');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return GenericVocabularyService;
}());
exports.GenericVocabularyService = GenericVocabularyService;
